'use client';

import selectEnergyLabelInformationTrigger from '@coolblue-development/ga4-events/triggers/AddToCartPage/selectEnergyLabelInformationTrigger';
import showEnergyLabelTrigger from '@coolblue-development/ga4-events/triggers/AddToCartPage/showEnergyLabelTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import NextEnergyLabel from '@coolblue-development/next-energy-label/client';
import type { EnergyLabel } from '@features/add-to-cart-page/typings/Product';

type Props = {
  energyLabel: EnergyLabel;
};

export default function EnergyLabel({ energyLabel }: Props) {
  const { trackEvent } = useAnalytics();

  const onEnergyLabelShow = () => {
    trackEvent(showEnergyLabelTrigger());
  };

  const onEnergyLabelContentClick = (
    content: 'product_information_sheet' | 'energy_label_image'
  ) => {
    trackEvent(
      selectEnergyLabelInformationTrigger({
        content
      })
    );
  };

  return (
    <NextEnergyLabel
      direction='right'
      imageId={energyLabel?.image?.id ? Number(energyLabel?.image?.id) : undefined}
      level={energyLabel.level}
      onShow={onEnergyLabelShow}
      onContentClick={onEnergyLabelContentClick}
      specificationUrl={energyLabel?.specification?.absoluteUrl ?? undefined}
      version={energyLabel.version}
    />
  );
}
